import { fetchEndpoint } from "../network";

/**
 * 首页推荐 - 轮播图
 */

export default {
  // 添加
  add(data) {
    return fetchEndpoint("/comment/add", "POST", data);
  },
  // 列表
  list(params) {
    return fetchEndpoint("/create-platform/content/comments", "GET", params);
  },
  //锁定
  lock(params) {
    return fetchEndpoint("/content/article/lock", "GET", params);
  },
  // 详情
  detail(params) {
    return fetchEndpoint("/create-platform/content/detail", "GET", params);
  },

  // 回复评论列表
  replys(params) {
    return fetchEndpoint("/create-platform/content/detailList", "GET", params);
  },

  // 入库
  toStorage(params) {
    return fetchEndpoint("/create-platform/content/preserve", "POST", params);
  },

  // 编辑
  modify(params) {
    return fetchEndpoint("/create-platform/content/modify", "POST", params);
  },

  // 删除
  remove(params) {
    return fetchEndpoint(
      "/create-platform/content/removeComments",
      "POST",
      params
    );
  },
  //之前没有这个，不知是否需要加/create-platform
  removeAttachment(params) {
    return fetchEndpoint("/comment/removeAttachment", "POST", params);
  },
  // 寻找标签
  findTags(params) {
    return fetchEndpoint("/create-platform/tag/findTags", "POST", params);
  },
};
